export enum ManualDequeueMethod {
  forceStart = 'forceStart',
  defer = 'defer'
}
